import { render, staticRenderFns } from "./ColorDropdown.vue?vue&type=template&id=683dcf82&scoped=true&"
import script from "./ColorDropdown.vue?vue&type=script&lang=ts&"
export * from "./ColorDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ColorDropdown.vue?vue&type=style&index=0&id=683dcf82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683dcf82",
  null
  
)

export default component.exports